import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutComponent } from './layout/layouts/empty/empty.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Client routes
    {
        path: 'client/telegram',
        data: {
            layout: 'empty',
            theme: 'theme-teal'
        },
        component: LayoutComponent,
        children: [
            { path: 'set-account-nickname', loadChildren: () => import('app/modules/client/telegram/set-account-nickname/client-set-account-nickname.routes') },
            { path: 'add-account', loadChildren: () => import('app/modules/client/telegram/signin/client-signin.routes') },
            { path: 'select-account', loadChildren: () => import('app/modules/client/telegram/select-account/client-select-account.routes') },
            { path: 'approve-c2c-wallet-deposit', loadChildren: () => import('app/modules/client/telegram/approve-c2c-wallet-deposit/approve-c2c-wallet-deposit.routes') },
            { path: 'admin-reply-to-customer-message', loadChildren: () => import('app/modules/client/telegram/admin-reply-to-customer-message/admin-reply-to-customer-message.routes') },
            { path: 'wallet-transactions', loadChildren: () => import('app/modules/client/telegram/customer-wallet-transactions/customer-wallet-transactions.routes') },
            {
                path: 'pg', loadChildren: () => import('app/modules/client/telegram/pg/pg.routes')
            },
        ]
    },

    {
        path: 'pg',
        data: {
            layout: 'empty',
            theme: 'theme-teal'
        },
        component: LayoutComponent,
        loadChildren: () => import('app/modules/client/telegram/pg/pg.routes')
    },

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ]
    },

    // // Admin routes
    // {
    //     path: '',
    //     canActivate: [AuthGuard],
    //     canActivateChild: [AuthGuard],
    //     component: LayoutComponent,
    //     resolve: {
    //         initialData: initialDataResolver
    //     },
    //     children: [
    //         {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
    //     ]
    // },
    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            { path: 'listing', loadChildren: () => import('app/modules/admin/components/listing/listing.route.module').then(m => m.ListingRouteModule) },
            { path: 'account/detail', loadChildren: () => import('app/modules/admin/detail/account/account-detail.module').then(m => m.AccountDetailModule) },
            { path: 'user/detail', loadChildren: () => import('app/modules/admin/detail/user/user-detail.module').then(m => m.UserDetailModule) },

            // dummy dashboard path, AuthGuard will redirect to the admin detail page.
            { path: 'dashboard', loadComponent: () => null },
        ]
    },
];
